import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { ExcelFile, ExcelSheet, ExcelColumn } from 'react-xlsx-wrapper';
import CustomLoading from '../../../util_components/custom_loading';
import CustomModal from '../../../util_components/custom_modal';
import CommonHeader from '../../../util_components/common_header';
import CustomInput from '../../../util_components/custom_input';
import { post_api } from '../../../../redux/api_funcs';
import { time_format, day_format_year } from '../../../../constants';
import * as actions from '../../../../redux/action_creators';
import { get_api_url } from '../../../../utils/urls';
import Button from '../../../util_components/button';

class StudentTransactions extends Component {
  state = {
    loading: true,
    single_trans_open: true,
    subscription_open: true,
    refund_reason: '',
    create_err: false,
    sessions_open: false,
    sessions: [],
    refund_open: false,
    refund_amount: 0,
    confirm_resend: false,
    charge_open: false,
    charge_amount: 0,
    charge_reason: '',
    charge_confirm: false,
    single_transactions: [],
    session_transactions: [],
    sess_trans_open: false,
    student_details: {},
    currency_symbol: '',
    max_refund_amount_available: 0,
    discounts_open: false,
    discounts: [],
    subscription_transactions: []
  };

  componentDidMount() {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const student_uuid = url.searchParams.get('id');
    const user_name = url.searchParams.get('name');
    // When ops are routed here from an immediate downgrade, the amount to collect
    // and a suggested reason come along as query params so we pre-fill and auto-open
    // the charge modal (the downgrade intentionally persisted purchase_price = 0).
    const charge_amount_param = url.searchParams.get('charge_amount');
    const charge_reason_param = url.searchParams.get('charge_reason');
    const prefill_charge = charge_amount_param !== null && Number(charge_amount_param) > 0;
    this.setState(
      {
        student_uuid,
        user_name,
        ...(prefill_charge
          ? {
              charge_open: true,
              charge_amount: Number(charge_amount_param),
              charge_reason: charge_reason_param || ''
            }
          : {})
      },
      () => this.load_transaction_details()
    );
  }

  load_transaction_details = () => {
    const url = get_api_url('list_all_transactions');
    const payload = { student_uuid: this.state.student_uuid, recurring: 0 };
    this.get_all_transaction_details(url, payload);
  };

  get_all_transaction_details = async (url, payload) => {
    try {
      const response = await post_api(url, payload, true);
      const { transaction, single_transactions, student_details } = response.data;

      this.setState(
        {
          session_transactions: [...transaction],
          single_transactions: [...single_transactions],
          student_details: { ...student_details },
          loading: true
        },
        () => {
          this.get_recurring_transaction_details(url);
        }
      );
    } catch (error) {
      this.setState({ loading: false });
      console.error('Error in fetching transaction_details', error);
    }
  };

  get_recurring_transaction_details = async (url) => {
    try {
      const { student_uuid } = this.state;
      const payload = { student_uuid, recurring: 1 };
      const response = await post_api(url, payload, true);
      const { transaction: subscription_transactions } = response.data;
      this.setState({
        subscription_transactions: [...subscription_transactions],
        currency_symbol: subscription_transactions[0]?.currency_symbol || '$',
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Error in fetching recurring_transaction_details', error);
    }
  };

  go_back = () => {
    this.props.history.goBack();
  };

  toggle_single_trans = () => this.setState({ single_trans_open: !this.state.single_trans_open });

  toggle_sess_trans = () => this.setState({ sess_trans_open: !this.state.sess_trans_open });

  go_to_email = () => {
    const { charge_amount, charge_reason, student_uuid, student_details } = this.state;
    this.props.history.push({
      pathname: '/createemail',
      state: {
        load_email: true,
        from_transaction: true,
        amount: charge_amount,
        reason: charge_reason,
        student_uuid,
        email: student_details.email,
        name: student_details.first_name
      }
    });
  };

  render_transaction_details = (transaction) => {
    let link_url = '';
    if (transaction.charge_reason === 'WORKSHOP_PURCHASE' && !!transaction.workshop_uuid) {
      link_url = `/workshop/${transaction.workshop_uuid}`;
    }
    if (transaction.session_uuid) {
      link_url = `/sessiondetails?id=${transaction.workshop_uuid}`;
    }
    if (link_url) {
      return (
        <a href={link_url} className="link-btn">
          Details
        </a>
      );
    }
    return '--';
  };

  get_reason_breakup = (reason) => {
    try {
      return reason.split('_').join(' ');
    } catch (e) {
      return reason;
    }
  };

  render_single_transactions = () => {
    const { single_transactions, single_trans_open } = this.state;
    return (
      <div>
        <div
          className="details-session-logs-header student-transactions"
          onClick={this.toggle_single_trans}
        >
          Single Transactions: {single_transactions.length}
          {single_transactions.length !== 0 ? (
            <img
              className={single_trans_open ? 'reverse-expand' : 'normal-expand'}
              src="https://images.myyogateacher.com/icons/ic_expand_arrow_white.png"
              alt="exp"
            />
          ) : null}
        </div>
        {single_transactions.length !== 0 && single_trans_open ? (
          <div className="cus-table">
            <div className="ct-row ct-h">
              <div className="ct-col ct-hf ct-sm-font">Invoice id</div>
              <div className="ct-col ct-hf ct-sm-font">Price</div>
              <div className="ct-col ct-sm-font">Reason</div>
              <div className="ct-col ct-hf ct-sm-font">Transaction Date</div>
              <div className="ct-col ct-hf ct-sm-font">Refunded Amount</div>
              <div className="ct-col ct-hf ct-sm-font">Refunded By</div>
              <div className="ct-col ct-hf ct-sm-font">Reason</div>
              <div className="ct-col ct-hf ct-sm-font">Refund</div>
              <div className="ct-col ct-hf ct-sm-font">Discounts</div>
              <div className="ct-col ct-hf ct-sm-font">Details</div>
            </div>
            {single_transactions.map((transaction) => (
              <div className="ct-row" key={transaction.invoice_id}>
                <div
                  className="ct-col ct-hf ct-sm-font ct-bw"
                  style={{
                    fontSize: '10px !important'
                  }}
                >
                  {transaction.invoice_id}
                </div>
                <div className="ct-col ct-hf">{transaction.purchase_price}</div>
                <div className="ct-col ct-sm-font">
                  {this.get_reason_breakup(transaction.charge_reason)}
                </div>
                <div className="ct-col ct-sm-font ct-hf">
                  <div>
                    {moment(transaction.purchase_date)
                      .tz(this.props.iana_timezone)
                      .format(day_format_year)}
                  </div>
                  <div>
                    {moment(transaction.purchase_date)
                      .tz(this.props.iana_timezone)
                      .format(time_format)}
                  </div>
                </div>
                <div className="ct-col ct-hf">{transaction.refund_amount}</div>
                <div className="ct-col ct-hf">{transaction?.refunded_by}</div>
                <div className="ct-col ct-hf">{transaction?.refund_reason}</div>

                <div className="ct-col ct-hf">
                  {transaction.purchase_price > 0 &&
                  transaction.purchase_price > transaction.refund_amount ? (
                    <button
                      className="ct-small-btn"
                      onClick={() =>
                        this.open_refund(
                          transaction.charge_id,
                          transaction.currency_symbol,
                          transaction.max_refund_amount_available
                        )
                      }
                    >
                      Refund
                    </button>
                  ) : (
                    '--'
                  )}
                </div>
                <div className="ct-col ct-hf">
                  {!!transaction.discounts && transaction.discounts.length > 0 ? (
                    <button
                      className="ct-small-btn"
                      onClick={() => this.view_discounts(transaction.invoice_id, 'single')}
                    >
                      View
                    </button>
                  ) : (
                    '--'
                  )}
                </div>
                <div className="ct-col ct-hf">{this.render_transaction_details(transaction)}</div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  };

  render_session_transactions = () => {
    const { session_transactions, sess_trans_open } = this.state;
    return (
      <div>
        <div
          className="details-session-logs-header student-transactions"
          onClick={this.toggle_sess_trans}
        >
          Session Transactions: {session_transactions.length}
          {session_transactions.length !== 0 ? (
            <img
              className={sess_trans_open ? 'reverse-expand' : 'normal-expand'}
              src="https://images.myyogateacher.com/icons/ic_expand_arrow_white.png"
              alt="exp"
            />
          ) : null}
        </div>
        {session_transactions.length !== 0 && sess_trans_open ? (
          <div className="cus-table" style={{ marginBottom: '20px' }}>
            <div className="ct-row ct-h">
              <div className="ct-col">Invoice Id</div>
              <div className="ct-col ct-hf">Price</div>
              <div className="ct-col ct-hf">Teacher</div>
              <div className="ct-col">Transaction Time</div>
              <div className="ct-col">Sesson Time</div>
              <div className="ct-col ct-hf">Student</div>
            </div>
            {session_transactions.map((transaction) => {
              const teacher_url = `/teacherprofile?id=${transaction.teacher_uuid}`;
              const student_url = `/studentprofile?id=${transaction.student_uuid}`;
              return (
                <div className="ct-row" key={transaction.invoice_id}>
                  <div className="ct-col">{transaction.invoice_id}</div>
                  <div className="ct-col ct-hf">{transaction.purchase_price}</div>
                  <div className="ct-col ct-hf">
                    <a className="link-no-dec" href={teacher_url}>
                      {transaction.teacher_name}
                    </a>
                  </div>
                  <div className="ct-col">{transaction.transaction_date}</div>
                  <div className="ct-col">{transaction.session_student_time}</div>
                  <div className="ct-col ct-hf">
                    <a className="link-no-dec" href={student_url}>
                      {transaction.student_name}
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  };

  toggle_subscription_open = () =>
    this.setState({ subscription_open: !this.state.subscription_open });

  view_sessions = (id) => {
    const { subscription_transactions } = this.state;
    const index = subscription_transactions.findIndex((s) => s.invoice_id === id);
    const sessions = subscription_transactions[index].session_lists;
    this.setState({ sessions, sessions_open: true });
  };

  view_discounts = (id, type = 'subscription') => {
    let { subscription_transactions } = this.state;
    if (type === 'single') {
      subscription_transactions = this.state.single_transactions;
    }
    const index = subscription_transactions.findIndex((s) => s.invoice_id === id);
    const { discounts } = subscription_transactions[index];
    this.setState({ discounts, discounts_open: true });
  };

  open_session_details = (id) => {
    const search = `?id=${id}`;
    const pathname = '/sessiondetails';
    this.props.history.push({ pathname, search });
  };

  render_sessions = () => {
    const { sessions } = this.state;
    const file_name = `Student_transactions_${moment().format('YYYY-MM-DD')}`;
    const download_data = sessions.map((s) => ({
      teacher_name: s.teacher_name,
      start_time: moment(s.start_time).tz(this.props.iana_timezone).format('YYYY-MM-DD hh:mm z'),
      duration: s.duration,
      finished: s.session_status === 'FINISHED',
      cancelled: s.session_status === 'CANCELLED',
      cancelled_less: s.session_status === 'NO_SHOW_CANCELLATION_1HOUR'
    }));
    if (this.state.sessions_open) {
      return (
        <div style={{ marginTop: '20px' }}>
          {sessions.length > 0 ? (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="teachers-count">Sessions:</div>
                <div style={{ textAlign: 'right' }}>
                  <ExcelFile
                    element={<button className="data-download-btn">Download Data</button>}
                    filename={file_name}
                  >
                    <ExcelSheet data={download_data} name="Transactions">
                      <ExcelColumn label="Teacher" value="teacher_name" />
                      <ExcelColumn label="Start Time" value="start_time" />
                      <ExcelColumn label="Duration" value="duration" />
                      <ExcelColumn label="Finished" value="finished" />
                      <ExcelColumn label="Cancelled" value="cancelled" />
                      <ExcelColumn label="Cancelled less than 1 hour" value="cancelled_less" />
                    </ExcelSheet>
                  </ExcelFile>
                </div>
              </div>
              <div className="cus-table" style={{ marginBottom: '20px' }}>
                <div className="ct-row ct-h">
                  <div className="ct-col">Teacher</div>
                  <div className="ct-col">Start Time</div>
                  <div className="ct-col">Duration</div>
                  <div className="ct-col ct-hf">Finished</div>
                  <div className="ct-col ct-hf">Cancelled less than 1 hour</div>
                </div>
                {sessions.map((sess) => {
                  const teacher_url = `/teacherprofile?id=${sess.teacher_uuid}`;
                  const sess_url = `/sessiondetails?id=${sess.session_uuid}`;
                  return (
                    <div className="ct-row" key={sess.session_uuid}>
                      <div className="ct-col">
                        <a className="link-no-dec" href={teacher_url}>
                          {sess.teacher_name}
                        </a>
                      </div>
                      <div className="ct-col ct-sm-font">
                        <a className="link-no-dec" href={sess_url}>
                          <div>
                            {moment(sess.start_time)
                              .tz(this.props.iana_timezone)
                              .format(day_format_year)}
                          </div>
                          <div>
                            {moment(sess.start_time)
                              .tz(this.props.iana_timezone)
                              .format(time_format)}
                          </div>
                        </a>
                      </div>
                      <div className="ct-col">{sess.duration}</div>
                      <div className="ct-col ct-si ct-hf">
                        {sess.session_status === 'FINISHED' ? (
                          <img
                            src="https://images.myyogateacher.com/icons/ic-checkmark-48.png"
                            alt="Yes"
                          />
                        ) : (
                          <img
                            src="https://images.myyogateacher.com/icons/ic-delete-48.png"
                            alt="No"
                          />
                        )}
                      </div>
                      <div className="ct-col ct-si ct-hf">
                        {sess.session_status === 'NO_SHOW_CANCELLATION_1HOUR' ? (
                          <img
                            src="https://images.myyogateacher.com/icons/ic-checkmark-48.png"
                            alt="Yes"
                          />
                        ) : (
                          <img
                            src="https://images.myyogateacher.com/icons/ic-delete-48.png"
                            alt="No"
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      );
    }
    return null;
  };

  open_refund = (charge_id, currency_symbol, max_refund_amount_available) =>
    this.setState({ charge_id, currency_symbol, max_refund_amount_available, refund_open: true });

  close_refund = () =>
    this.setState({
      refund_open: false,
      confirm_resend: false,
      charge_confirm: false,
      charge_reason: '',
      charge_open: false,
      charge_amount: 0,
      discounts_open: false,
      discounts: [],
      refund_amount: 0,
      refund_reason: ''
    });

  render_discounts = () => {
    const { discounts } = this.state;
    return (
      <div>
        <h4>Discounts and extra credits</h4>
        <div className="cus-table" style={{ marginBottom: '20px' }}>
          <div className="ct-row ct-h">
            <div className="ct-col ct-sm-font">Type</div>
            <div className="ct-col ct-sm-font">Name</div>
            <div className="ct-col ct-sm-font">value</div>
            <div className="ct-col ct-sm-font">Code</div>
            <div className="ct-col ct-sm-font">Offer Name</div>
          </div>
          {discounts.map((d) => (
            <div className="ct-row">
              <div className="ct-col ct-sm-font">{d.type}</div>
              <div className="ct-col ct-sm-font">{d.name}</div>
              <div className="ct-col ct-sm-font">{d.value}</div>
              <div className="ct-col ct-sm-font">{d.coupon_code}</div>
              <div className="ct-col ct-sm-font">{d.coupon_code_name}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  render_subscriptions = () => {
    const { subscription_transactions, subscription_open } = this.state;

    const final_tranasctions = subscription_transactions.filter(
      (s) => s.subscription_status !== 'FUTURE'
    );

    return (
      <div>
        <div
          className="details-session-logs-header student-transactions"
          onClick={this.toggle_subscription_open}
        >
          Subscription Transactions: {final_tranasctions.length}
          {final_tranasctions.length !== 0 && (
            <img
              className={subscription_open ? 'reverse-expand' : 'normal-expand'}
              src="https://images.myyogateacher.com/icons/ic_expand_arrow_white.png"
              alt="exp"
            />
          )}
        </div>

        {final_tranasctions.length !== 0 && subscription_open && (
          <div className="cus-table text-[10px] mb-5 overflow-x-auto">
            <div className="min-w-[1500px]">
              <div className="grid grid-cols-[repeat(14,minmax(0,1fr))] gap-2 font-semibold bg-gray-100 dark:bg-gray-700 py-2 px-2 border-b border-gray-300 dark:border-gray-600">
                <div>Invoice Id</div>
                <div>Package</div>
                <div>Purchase Date</div>
                <div>Price</div>
                <div>Status</div>
                <div>Transaction Source</div>
                <div>Next Billing</div>
                <div>Discounts</div>
                <div>Refund</div>
                <div>Reason</div>
                <div>Usage</div>
                <div>Refund</div>
                <div>Receipt</div>
                <div>Created Date</div>
              </div>

              {final_tranasctions.map((transaction) => {
                const noOfRecordingsViewed = transaction.recording_playback_lists.length;
                const oneOneOneJoined = transaction.session_lists.filter(
                  (sess) => sess.session_type === 'YOGA' && sess.session_status === 'FINISHED'
                ).length;
                const groupClassesJoined = transaction.session_lists.filter(
                  (sess) =>
                    sess.session_type === 'GROUP_SESSION_STUDENT' &&
                    sess.session_status === 'FINISHED'
                ).length;
                const oneOnOneNoJoin =
                  transaction.session_lists.length - (oneOneOneJoined + groupClassesJoined);

                //   const paymentSelected = subscription_transactions.filter((transaction) => transaction.charge_id === charge_id)?.[0]
                return (
                  <div
                    key={transaction.invoice_id}
                    className="grid grid-cols-[repeat(14,minmax(0,1fr))] gap-2 py-2 px-2 border-b border-gray-200 dark:border-gray-700 items-center"
                  >
                    <div>{transaction.invoice_id}</div>
                    <div className=" max-w-[60px]">{transaction.package_name}</div>
                    <div>
                      <div>
                        {moment(transaction.purchase_date)
                          .tz(this.props.iana_timezone)
                          .format(day_format_year)}
                      </div>
                      <div>
                        {moment(transaction.purchase_date)
                          .tz(this.props.iana_timezone)
                          .format(time_format)}
                      </div>
                    </div>
                    <div>
                      {`${transaction.currency_symbol} ${transaction.purchase_price} ${transaction.ywf_repeat_price > 0 ? `(${transaction.ywf_repeat_price})` : ''}`}
                    </div>
                    <div className="relative">
                      {transaction.transaction_success === 1 ? (
                        <img
                          src="https://images.myyogateacher.com/icons/ic-checkmark-48.png"
                          alt="Success"
                          className="w-4 h-4"
                        />
                      ) : (
                        <div className="relative group">
                          <img
                            src="https://images.myyogateacher.com/icons/ic-delete-48.png"
                            alt="Failed"
                            className="w-4 h-4 cursor-pointer"
                          />
                          <div className="tooltiptexts">
                            {transaction?.transaction_failure_reason ??
                              'Reach out to tech team for more information'}
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className="max-w-[80px] truncate"
                      title={transaction?.transaction_source ?? ''}
                    >
                      {transaction?.transaction_source ?? '--'}
                    </div>
                    <div>
                      <div>
                        {moment(transaction.next_billing_date)
                          .tz(this.props.iana_timezone)
                          .format(day_format_year)}
                      </div>
                      <div>
                        {moment(transaction.next_billing_date)
                          .tz(this.props.iana_timezone)
                          .format(time_format)}
                      </div>
                    </div>
                    <div>
                      {transaction.discounts?.length ? (
                        <button
                          className="ct-small-btn"
                          onClick={() => this.view_discounts(transaction.invoice_id)}
                        >
                          View
                        </button>
                      ) : (
                        '--'
                      )}
                    </div>
                    <div>
                      <div>{`${transaction.refund_amount > 0 ? transaction.currency_symbol : ''} ${transaction.refund_amount}`}</div>
                      <div>{transaction?.refunded_by}</div>
                    </div>

                    <div>{transaction?.refund_reason}</div>
                    <div className="grid gap-[2px] text-[10px]">
                      <div>1-on-1: {oneOneOneJoined ?? '--'}</div>
                      <div>Group: {groupClassesJoined ?? '--'}</div>
                      <div>No Join: {oneOnOneNoJoin ?? '--'}</div>
                      <div>Recordings: {noOfRecordingsViewed ?? '--'}</div>
                    </div>
                    <div>
                      {transaction.purchase_price > 0 &&
                        transaction.purchase_price > transaction.refund_amount && (
                          <button
                            className="ct-small-btn"
                            onClick={() =>
                              this.open_refund(
                                transaction.charge_id,
                                transaction.currency_symbol,
                                transaction.max_refund_amount_available
                              )
                            }
                          >
                            Refund
                          </button>
                        )}
                    </div>
                    <div>
                      {transaction.purchase_price > 0 && (
                        <button
                          className="ct-small-btn"
                          onClick={() => this.confirm_resend(transaction.order_id)}
                        >
                          Resend
                        </button>
                      )}
                    </div>
                    <div>
                      {transaction.created_date ? (
                        <>
                          <div>
                            {moment(transaction.created_date)
                              .tz(this.props.iana_timezone)
                              .format(day_format_year)}
                          </div>
                          <div>
                            {moment(transaction.created_date)
                              .tz(this.props.iana_timezone)
                              .format(time_format)}
                          </div>
                        </>
                      ) : (
                        '--'
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  confirm_resend = (order_id) => this.setState({ confirm_resend: true, order_id });

  get_transaction_row_by_charge_id = (charge_id) => {
    const { subscription_transactions = [], single_transactions = [] } = this.state;
    return (
      subscription_transactions.find((t) => t.charge_id === charge_id) ||
      single_transactions.find((t) => t.charge_id === charge_id)
    );
  };

  get_effective_max_refund = (charge_id, stateMaxRefund) => {
    const row = this.get_transaction_row_by_charge_id(charge_id);
    const raw = row?.max_refund_amount_available ?? stateMaxRefund;
    const parsed = Number.parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  initiate_refund = () =>
    this.setState({ loading: true }, () => {
      const { refund_amount, refund_reason, charge_id, max_refund_amount_available } = this.state;
      const isSuperAdmin = this.props.config_values?.user_access === 'SUPER_USER';
      const effectiveMaxRefund = this.get_effective_max_refund(
        charge_id,
        max_refund_amount_available
      );
      if (refund_reason && refund_reason.trim().length >= 10) {
        const url = get_api_url('refund_transaction');
        const payload = { charge_id, refund_reason };
        if (refund_amount > 0) {
          payload.amount = refund_amount.toString();
        }
        if (isSuperAdmin && refund_amount > effectiveMaxRefund) {
          payload.bypass_refund_limits = 1;
        }
        post_api(url, payload, true)
          .then(() => {
            this.props.set_notification_variable(true, 'success', 'Refund added');
            this.setState({
              refund_open: false,
              refund_amount: 0,
              refund_reason: ''
            });
            this.load_transaction_details();
          })
          .catch((e) => {
            let err_msg = 'Some error occured. Please contact dev team';
            try {
              const new_err_msg = e.response.data.message || e.response.data.reason;
              if (new_err_msg) {
                err_msg = new_err_msg;
              }
            } catch {}
            this.props.set_notification_variable(true, 'error', err_msg);
            this.setState({ loading: false });
          });
      } else {
        this.setState({ create_err: true, loading: true });
      }
    });

  resend_transaction_reciept = () =>
    this.setState({ loading: true }, () => {
      const { order_id } = this.state;

      const url = get_api_url('resend_receipt');
      const payload = { order_id };
      post_api(url, payload, true)
        .then(() => {
          this.props.set_notification_variable(true, 'success', 'Receipt Sent');
          this.setState({ refund_open: false, confirm_resend: false, loading: false });
        })
        .catch((e) => {
          let err_msg = 'Some error occured. Please contact dev team';
          try {
            const new_err_msg = e.response.data.message || e.response.data.reason;
            if (new_err_msg) {
              err_msg = new_err_msg;
            }
          } catch {}
          this.props.set_notification_variable(true, 'error', err_msg);
          this.setState({ loading: false });
        });
    });

  render_refund = () => {
    const {
      charge_id,
      refund_amount,
      refund_reason,
      create_err,
      currency_symbol,
      max_refund_amount_available: stateMaxRefund
    } = this.state;
    const err_sty = create_err ? { opacity: 1, color: '#ed4d4d' } : { opacity: 0 };
    const symbol = currency_symbol || '$';
    const paymentSelected = this.get_transaction_row_by_charge_id(charge_id);
    const maxRefundPossible = this.get_effective_max_refund(charge_id, stateMaxRefund);
    const purchasePrice = parseFloat(paymentSelected?.purchase_price);
    const isSuperAdmin = this.props.config_values?.user_access === 'SUPER_USER';

    if (charge_id) {
      return (
        <div>
          <h4>Send refund to user</h4>
          <div className="flex items-center gap-2">
            <CustomInput
              label={`Refund amount (${symbol})`}
              onChange={(e) => {
                if (!isSuperAdmin && e.target.value > maxRefundPossible) {
                  return;
                }
                if (isSuperAdmin && e.target.value > purchasePrice) {
                  return;
                }
                this.on_number_change(e);
              }}
              name="refund_amount"
              max={maxRefundPossible}
              value={refund_amount}
              type="number"
              style={{ width: '150px' }}
            />
            <div className="text-sm text-gray-500 dark:text-gray-400 mt-6">
              {`Max Allowed:${symbol} ${maxRefundPossible}`}
            </div>
          </div>
          <CustomInput
            label="Refund reason"
            onChange={this.handle_change}
            name="refund_reason"
            value={refund_reason}
            style={{ width: '300px' }}
          />
          {refund_reason && refund_reason.trim().length < 10 && (
            <p style={{ color: '#ed4d4d', fontSize: '0.85em', marginTop: '4px' }}>
              {`Minimum 10 characters required (${refund_reason.trim().length}/10)`}
            </p>
          )}
          <button
            disabled={!refund_reason || refund_reason.trim().length < 10 || refund_amount <= 0}
            style={{
              opacity:
                !refund_reason || refund_reason.trim().length < 10 || refund_amount <= 0
                  ? '0.5'
                  : '1'
            }}
            onClick={this.initiate_refund}
          >
            Submit
          </button>
          <p style={err_sty}>Please enter a reason (minimum 10 characters)</p>
        </div>
      );
    }
    return (
      <div>
        <h4>No charge id to refund</h4>
      </div>
    );
  };

  on_number_change = (e) => this.setState({ [e.target.name]: parseFloat(e.target.value) });

  handle_change = (e) => this.setState({ [e.target.name]: e.target.value });

  render_confirm_resend = () => (
    <div>
      <h4>Resend Receipt?</h4>
      <button onClick={this.resend_transaction_reciept}>Confirm</button>
      <button onClick={this.close_refund}>Back</button>
    </div>
  );

  charge_user = () =>
    this.setState({ loading: true }, () => {
      const url = get_api_url('charge_user');
      const { charge_amount, charge_reason, charge_confirm, student_uuid } = this.state;
      const payload = { student_uuid, amount: charge_amount, reason: charge_reason };
      post_api(url, payload, true)
        .then((res) => {
          this.close_refund();
          this.load_transaction_details();
        })
        .catch((e) => {
          let err_message;
          try {
            err_message = e.response.data.message;
          } catch (err) {
            err_message = 'Some error occured. Please contact dev team.';
          }
          this.props.set_notification_variable(true, 'error', err_message);
          this.setState({ loading: false });
        });
    });

  render_charge = () => {
    const { charge_amount, charge_reason, charge_confirm, currency_symbol } = this.state;
    if (charge_confirm) {
      return (
        <div>
          <h4>Are you sure you want to charge user?</h4>
          <p>{`Amount: ${currency_symbol}${charge_amount}`}</p>
          <p>{`Reason: ${charge_reason}`}</p>
          <button onClick={this.charge_user}>Confirm</button>
          <button onClick={() => this.setState({ charge_confirm: false })}>Cancel</button>
        </div>
      );
    }
    return (
      <div className="num-input-no-arr">
        <h4>Charge user</h4>
        <CustomInput
          label={`Charge amount  (${currency_symbol})`}
          onChange={this.on_number_change}
          name="charge_amount"
          value={charge_amount}
          type="number"
          style={{ width: '150px' }}
        />
        <CustomInput
          label="Charge reason*"
          onChange={this.handle_change}
          name="charge_reason"
          value={charge_reason}
          style={{ width: '300px' }}
        />
        <Button
          disabled={!charge_reason || charge_amount <= 0}
          onClick={() => this.setState({ charge_confirm: true })}
        >
          Submit
        </Button>
      </div>
    );
  };

  render_function = () => {
    const { loading, charge_open, discounts_open, subscription_transactions } = this.state;
    if (this.state.loading) {
      return <CustomLoading />;
    }
    const title = `Student transactions of ${this.state.user_name ? this.state.user_name.toUpperCase() : null}`;
    return (
      <CommonHeader loading={loading} title={title} show_back>
        {!(Array.isArray(subscription_transactions) && subscription_transactions.length === 0) && (
          <button onClick={() => this.setState({ charge_open: true })}>Charge User</button>
        )}
        <CustomModal show={this.state.refund_open} close={this.close_refund}>
          {this.render_refund()}
        </CustomModal>
        <CustomModal show={this.state.confirm_resend} close={this.close_refund}>
          {this.render_confirm_resend()}
        </CustomModal>
        <CustomModal show={charge_open} close={this.close_refund}>
          {this.render_charge()}
        </CustomModal>
        <CustomModal show={discounts_open} close={this.close_refund}>
          {this.render_discounts()}
        </CustomModal>
        {this.render_session_transactions()}
        {this.render_single_transactions()}
        {this.render_subscriptions()}
        {this.render_sessions()}
      </CommonHeader>
    );
  };

  render() {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Student Transactions</title>
        </Helmet>
        {this.render_function()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  iana_timezone: state.home.iana_timezone,
  config_values: state.home.config_values
});

const mapDispatchToProps = (dispatch) => ({
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentTransactions);
